import { Box } from '@wix/design-system';
import { Confirm } from '@wix/wix-ui-icons-common';
import React from 'react';
export const SelectedIcon = ({ color = '#116DFF', size = '18px', icon = React.createElement(Confirm, { color: "white" }), top = '-5px', right = '-5px', }) => {
    return (React.createElement(Box, { position: "absolute", top: top, right: right, zIndex: 3, width: size, height: size, borderRadius: "50%", backgroundColor: color, align: "center", verticalAlign: "middle" }, icon));
};
//# sourceMappingURL=SelectedIcon.js.map